import { Intent } from '../../ui';
import { AppToaster } from '../../../utils/toaster';
import { DiscardErrorCallback, ErrorIdentifier } from './error-identifier';

export const invalidResetPasswordCodeErrorIdentifier: ErrorIdentifier = (
  index: number,
  error: any,
  discard: DiscardErrorCallback
) => {
  if (
    error.message.indexOf('(/accountPasswordReset)') === -1 ||
    error.message.indexOf('Parameter `code` must be valid') === -1
  ) {
    return null;
  }

  discard(error);

  AppToaster.show({
    intent: Intent.DANGER,
    icon: 'warning-sign',
    message: 'This request is no longer valid.',
  });

  return false;
};
